import { render, staticRenderFns } from "./FormItemLayout.vue?vue&type=template&id=f47b17aa&"
import script from "./FormItemLayout.vue?vue&type=script&lang=js&"
export * from "./FormItemLayout.vue?vue&type=script&lang=js&"
import style0 from "./FormItemLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f47b17aa')) {
      api.createRecord('f47b17aa', component.options)
    } else {
      api.reload('f47b17aa', component.options)
    }
    module.hot.accept("./FormItemLayout.vue?vue&type=template&id=f47b17aa&", function () {
      api.rerender('f47b17aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/FormItemLayout.vue"
export default component.exports